/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Component, OnDestroy, OnInit } from '@angular/core';
import { NbDialogService, NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService } from '@nebular/theme';
import { LayoutService } from '../../../@core/utils';
import { map, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { UserStore } from '../../../@core/stores/user.store';
import { SettingsData } from '../../../@core/interfaces/common/settings';
import { User } from '../../../@core/interfaces/common/users';
import { Router } from '@angular/router';
import { ContactUsComponent } from '../../../pages/contact-us/contact-us.component';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { ApplicationApi } from '../../../@core/backend/common/api/application.api';
import { environment } from '../../../../environments/environment';


@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {

  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  firstForm: FormGroup;
  user: User;

  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    
    {
      value: 'corporate',
      name: 'Corporate',
    },
  ];

  currentTheme = 'default';

  userMenu = this.getMenuItems();
  language: any;
  usersData: any;
  newapp: any;
  editFlag: any;
  app_id: any;
  getuser: any;
  edu_data: any;
  form: any;
  buildItemEducation: any;
  StudentApplyComponent: any;
  imageUrl = environment.imageUrl

  constructor(private fb: FormBuilder,
             private api: ApplicationApi,
              private sidebarService: NbSidebarService,
              private menuService: NbMenuService,
              private themeService: NbThemeService,
              private userStore: UserStore,
              private router : Router,
              private settingsService: SettingsData,
              private layoutService: LayoutService,
              private breakpointService: NbMediaBreakpointsService,
              private dialogService: NbDialogService,) {
  }

  getMenuItems() {
    const userLink = this.user ?  '/pages/users/current/' : '';
    return [
      { title: 'Change Password',link: './pages/changePassword' },
      { title: 'Log out', link: '/auth/logout' },
    ];
  }

  ngOnInit() {
    this.currentTheme = this.themeService.currentTheme;

    this.userStore.onUserStateChange()
      .pipe(
        takeUntil(this.destroy$),
      )
      .subscribe((user: User) => {
        this.user = user;
        this.userMenu = this.getMenuItems();
      });

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => this.currentTheme = themeName);

      this.firstForm = this.fb.group({
        languagectrl : this.fb.control('')
    
      });

      this.getdata()
      
  }
  getdata(){
    
        this.api.getalldata(this.newapp,this.editFlag,this.app_id).subscribe(data => {
          if(data['status'] == 200){
            this.getuser=data['getuser'][0]['user_type']
            this.firstForm.patchValue({
              languagectrl :  this.language
            })   
          }
      });
      }
  
  onChange(value){
    
    
    this.language = this.firstForm.controls.languagectrl.value;
    
    // this.degree=this.user.degreeCtrl.includes("Bachelor");
    // if(this.degree){
    //   this.bac='Bachelor'
    // }else if(){  addAppliedFor
  
    // }
    this.api.appliedForlanguage(value).subscribe(data => {
      if(data['status']==200){
        
        
        this.ngOnInit()
      }
    
    
    });
  }
   getalldata(){
  this.api.getalldata(this.newapp,this.editFlag,this.app_id).subscribe(data => {
    if(data['status'] == 200){
    this.ngOnInit();
      this.StudentApplyComponent()
      this.edu_data=data['data']
      
      this.getuser=data['getuser']
      this.language = this.getuser[0].language
      // this.ngOnInit()
        
      this.edu_data.forEach((element)=>{
        
      

        (<FormArray> this.form.controls['credentials']).push(this.buildItemEducation(element.applying_for));
      })
       
    }
});
  
 }
 
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeTheme(themeName: string) {
    this.userStore.setSetting(themeName);
    this.settingsService.updateCurrent(this.userStore.getUser().settings)
      .pipe(takeUntil(this.destroy$))
      .subscribe();

    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }
  demo(){
    this.router.navigateByUrl('/pages/faq');
  }

  open(){
    this.dialogService.open(ContactUsComponent).onClose.subscribe(data =>{
      // 
      
           
    });
  }
  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }
  navigate(){
    this.router.navigate(['pages/CartComponent']);

  }
}
